const accordionSelectors = {
	container: ".js-toggle-container",
	item: ".js-toggle-item",
	button: ".js-toggle-button",
	content: ".js-toggle-content"
};

const accordionAttributes = {
	accordionMode: "data-accordion-mode"
};

const accordionModifiers = {
	active: "active"
};

const accordionModes = {
	single: "single",
	multiple: "multiple"
};

(function () {
	const $container = $(accordionSelectors.container);
	const $button = $(accordionSelectors.button);

	if (!$button.length) {
		return null;
	}

	if ($container.length) {
		$container.on("click", accordionSelectors.button, toggleAccordion);
	} else {
		$button.on("click", toggleAccordion);
	}

	function toggleAccordion() {
		let $accordion = $(this).parent(accordionSelectors.item);

		let accordionContent = $accordion[0].querySelector(accordionSelectors.content);

		if (!accordionContent) {
			return null;
		}

		let $accordionContainer = $accordion.parents(accordionSelectors.container);

		if ($accordionContainer.length) {
			let accordionMode = $accordionContainer.attr(
				accordionAttributes.accordionMode
			);

			if (accordionMode === accordionModes.single) {
				let $openAccordions = $accordionContainer
					.find(`${accordionSelectors.item}.${accordionModifiers.active}`)
					.filter(function (index, el) {
						return el !== $accordion[0];
					});

				$openAccordions.removeClass(accordionModifiers.active);

				$openAccordions
					.find(accordionSelectors.content)
					.stop()
					.slideToggle(300, function () {
						$(this).css("height", "");
					});
			}
		}

		$accordion.toggleClass(accordionModifiers.active);

		$(accordionContent)
			.stop()
			.slideToggle(300, function () {
				$(this).css("height", "");
			});
	}
})();
